import './Stylesheet.scss';
import { ToastContainer } from 'react-toastify';
import Router from './Router';

require('dotenv').config();

const App = () => {
  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover />
      <Router />
    </div>
  );
}

export default App;